import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FaChevronRight } from 'react-icons/fa';
import styled from 'styled-components';
import { FormattedMessage, FormattedNumber } from '@techstyle/react-intl';
import Button from '../Button';
import { useProductBrowser } from '../ProductBrowserContext';
import { desktop } from '../styles';
var ButtonElement = styled(Button).withConfig({
  displayName: "FilterDrawerButton__ButtonElement",
  componentId: "sc-1dwackr-0"
})(["\n  height: 48px;\n  border: 0;\n  margin: 0;\n  padding: 0 16px;\n  font-family: inherit;\n  font-weight: normal;\n  font-size: 16px;\n  background: transparent;\n  color: #333;\n  cursor: pointer;\n\n  ", ";\n"], desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var Chevron = styled(FaChevronRight).withConfig({
  displayName: "FilterDrawerButton__Chevron",
  componentId: "sc-1dwackr-1"
})(["\n  font-size: 8px;\n  margin-bottom: 2px;\n  vertical-align: middle;\n"]);
var FilterCount = styled.span.withConfig({
  displayName: "FilterDrawerButton__FilterCount",
  componentId: "sc-1dwackr-2"
})(["\n  color: #676767;\n\n  ", ";\n"], _ref => {
  var filterCountStyle = _ref.filterCountStyle;
  return filterCountStyle;
});
var FilterDrawerButton = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var filterCountFromProps = _ref2.filterCount,
      filterCountStyle = _ref2.filterCountStyle,
      _ref2$afterLabelIcon = _ref2.afterLabelIcon,
      afterLabelIcon = _ref2$afterLabelIcon === void 0 ? /*#__PURE__*/React.createElement(Chevron, null) : _ref2$afterLabelIcon,
      beforeLabelIcon = _ref2.beforeLabelIcon,
      labelStyle = _ref2.labelStyle,
      labelFromProps = _ref2.label,
      rest = _objectWithoutProperties(_ref2, ["filterCount", "filterCountStyle", "afterLabelIcon", "beforeLabelIcon", "labelStyle", "label"]);

  var productBrowserCtx = useProductBrowser(); // default to 0 if no filterCountFromProps and no filterCountFromCtx are available

  var filterCount = 0;

  if (filterCountFromProps != null) {
    filterCount = filterCountFromProps;
  } else if (productBrowserCtx && productBrowserCtx.totalFilterCount != null) {
    filterCount = productBrowserCtx.totalFilterCount;
  }

  var label = labelFromProps !== null && labelFromProps !== void 0 ? labelFromProps : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_grid.filter_label",
    defaultMessage: "Filter"
  });
  var toggleFilterDrawer = useCallback(() => {
    if (productBrowserCtx) {
      productBrowserCtx.setFilterDrawerOpen(prevState => !prevState);
    }
  }, [productBrowserCtx]);
  return /*#__PURE__*/React.createElement(ButtonElement, _extends({
    "data-autotag": "filter-count",
    labelStyle: labelStyle,
    ref: ref,
    variant: "filterDrawerButton",
    onClick: toggleFilterDrawer
  }, rest), beforeLabelIcon, label, ' ', filterCount > 0 ? /*#__PURE__*/React.createElement(FilterCount, {
    filterCountStyle: filterCountStyle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_filter.filter_count",
    defaultMessage: "({filterCount})",
    values: {
      filterCount: /*#__PURE__*/React.createElement(FormattedNumber, {
        value: filterCount
      })
    }
  })) : null, ' ', afterLabelIcon);
});
FilterDrawerButton.displayName = 'FilterDrawerButton';
FilterDrawerButton.propTypes = {
  /**
   * Icon to display to the right of the label, defaults to chevron
   */
  afterLabelIcon: PropTypes.node,

  /**
   * Icon to display to the left of the label
   */
  beforeLabelIcon: PropTypes.node,
  filterCount: PropTypes.number,
  filterCountStyle: PropTypes.any,
  label: PropTypes.node,
  labelStyle: PropTypes.any,
  showChevronIcon: PropTypes.bool
};
export default FilterDrawerButton;